<template>
  <div class="q-img-container main-color">
    <label class="label-2cols q-label" v-html="question.q"></label>
    <div v-if="readOnly" class="image-panel" align="center">
      <img :src="imageURL" alt="Imagen">
    </div>
     <div v-if="!readOnly" class="image-panel" align="center">
      <md-button  v-if="!loading" class="md-success md-round md-fileinput">
        <i class="fa fa-upload"></i> Cargar Archivo
        <input
          ref="file"
          type="file"
          @change="onFileChange"
          name="image"
          data-vv-name="image"
          v-validate="modelValidations.image"
        />
      </md-button>
      <md-button 
        class="md-danger md-round"
        @click="removeFile"
        v-if="file_ && !loading"
        ><i class="fa fa-times"></i>Eliminar</md-button
      >
      <div v-if="loading">
          <md-progress-bar md-mode="indeterminate"></md-progress-bar>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "file-image-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
      answerProp: {
        type: String,
        default: ""
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      surveyIdProp:{
        type: String,
        default: "test"
      }
  },
  data: function() {
    return {
      answer: this.answerProp,
      disabled: this.readOnly,
      imageURL: this.$http.defaults.baseURL + "get_image/",
      resultId: "",
      urlComentarios: "",
      image: null,
      image_: null,
      imageName: null,
      file_: null,
      filename: null,
      loading: false,
      modelValidations: {
        image: {
          required_if: this.bodyType = "file",
          image: true,
          mimes: "image/*",
          size: 5242880
        }
      }
    };
  },
  methods: {
     emitValueFile: function() {
      //console.log(this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      let maxMB = 30;
      if (!files.length) return;
      if (files[0].size > 1024 * 1024 * maxMB) {
        alert(`El tamaño de la imagen es superior a los ${maxMB}MB`);
        //this.displayError("El tamaño de la imagen es superior a los 5MB", true);
        this.$refs.file.value = '';
        return;
      }
      this.loading = true;        
      this.filename = files[0].name;
      this.file_ = files[0];
      this.uploadFile();
    },
    removeFile: function(type) {
      this.$refs.file.value = '';
      this.filename = null;
      this.file_ = null;
    },
    uploadFile: function(){
      const formData = new FormData();
      const uploadUrl = `//pf.tigo.com.gt/v1/surveys/web/add_image/`;
      formData.append("file", this.file_);
      this.$http({
        method: "post",
        url: uploadUrl,
        data: formData,
        headers: {                
          "content-type": "multipart/form-data"
        }
      }).then(response => {
        this.loading = false;
        if (response.status == 200) {
          alert("Archivo cargado con éxito");
            this.answer = response.data.fileName;
            this.emitValueFile();
        }
      })
      .catch(error => {
        this.loading = false;
        alert("Error al enviar el archivo al servidor");
        //this.displayError("Error al enviar el registro en el servidor", true);
      });
      
    }
  },
  mounted: function() {
    if(this.readOnly == true){
      this.imageURL = this.imageURL + this.answer.replace(".enc", "");
    }
    
    this.resultId = this.$route.query.r;
  }
};
</script>

<style lang="scss" scoped>
    .centered-container {
        
        .loading-overlay {
            z-index: 10;
            top: 0;
            left: 0;
            right: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
